var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#006DF0;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#006DF0;}\n\t.st4{fill:none;stroke:#37CE93;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#37CE93;stroke-width:3;stroke-miterlimit:10;stroke-dasharray:27,4;}\n\t.st6{fill:none;stroke:#37CE93;stroke-width:3;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#006DF0;stroke-width:3;stroke-miterlimit:10;}\n\t.st8{fill:#37CE93;}\n\t.st9{fill:none;stroke:#37CE93;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 50,
    cy: 92,
    rx: 49,
    ry: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.76,
    y: 35.12,
    className: "st1",
    width: 70.18,
    height: 54.77
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.81,16.9h-5.39c-3.28,0-5.97,2.64-5.97,5.88l-0.04,59.9c0,3.24,2.58,6.22,5.86,6.22h43.15"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 42.62,
    y1: 16.9,
    x2: 31.11,
    y2: 16.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 65.65,
    y1: 16.9,
    x2: 54.03,
    y2: 16.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.71,55.44V22.55c0-3.24-2.36-5.65-5.64-5.65h-5.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 88.71,
    y1: 34.12,
    x2: 8.41,
    y2: 34.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.1,21c0,2.53-2.05,4.58-4.58,4.58c-2.53,0-4.58-2.05-4.58-4.58v-8.17c0-2.53,2.05-4.58,4.58-4.58 c2.53,0,4.58,2.05,4.58,4.58V21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.98,21c0,2.53-2.05,4.58-4.58,4.58c-2.53,0-4.58-2.05-4.58-4.58v-8.17c0-2.53,2.05-4.58,4.58-4.58 c2.53,0,4.58,2.05,4.58,4.58V21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.93,21c0,2.53-2.05,4.58-4.58,4.58c-2.53,0-4.58-2.05-4.58-4.58v-8.17c0-2.53,2.05-4.58,4.58-4.58 c2.53,0,4.58,2.05,4.58,4.58V21z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25.52,44.06v4.53h-5.95v-4.53H25.52 M25.52,41.06h-5.95c-1.66,0-3,1.34-3,3v4.53c0,1.66,1.34,3,3,3h5.95 c1.66,0,3-1.34,3-3v-4.53C28.52,42.4,27.17,41.06,25.52,41.06L25.52,41.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42.77,44.06v4.53h-5.95v-4.53H42.77 M42.77,41.06h-5.95c-1.66,0-3,1.34-3,3v4.53c0,1.66,1.34,3,3,3h5.95 c1.66,0,3-1.34,3-3v-4.53C45.77,42.4,44.43,41.06,42.77,41.06L42.77,41.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25.52,59.95v4.54h-5.95v-4.54H25.52 M25.52,56.95h-5.95c-1.66,0-3,1.34-3,3v4.54c0,1.66,1.34,3,3,3h5.95 c1.66,0,3-1.34,3-3v-4.54C28.52,58.3,27.17,56.95,25.52,56.95L25.52,56.95z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42.77,59.95v4.54h-5.95v-4.54H42.77 M42.77,56.95h-5.95c-1.66,0-3,1.34-3,3v4.54c0,1.66,1.34,3,3,3h5.95 c1.66,0,3-1.34,3-3v-4.54C45.77,58.3,44.43,56.95,42.77,56.95L42.77,56.95z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.77,56.95h-4.74c-1.66,0-3,1.34-3,3v4.54c0,1.66,1.34,3,3,3h1.73c0.83,0,1.5-0.67,1.5-1.5 c0-0.83-0.67-1.5-1.5-1.5h-1.73v-4.54l0,0l0,0h4.74c0.83,0,1.5-0.67,1.5-1.5S59.59,56.95,58.77,56.95L58.77,56.95z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25.52,75.73v4.54h-5.95v-4.54H25.52 M25.52,72.73h-5.95c-1.66,0-3,1.34-3,3v4.54c0,1.66,1.34,3,3,3h5.95 c1.66,0,3-1.34,3-3v-4.54C28.52,74.07,27.17,72.73,25.52,72.73L25.52,72.73z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42.77,75.73v4.54h-5.95v-4.54H42.77 M42.77,72.73h-5.95c-1.66,0-3,1.34-3,3v4.54c0,1.66,1.34,3,3,3h5.95 c1.66,0,3-1.34,3-3v-4.54C45.77,74.07,44.43,72.73,42.77,72.73L42.77,72.73z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60,44.06v4.53h-5.95v-4.53H60 M60,41.06h-5.95c-1.66,0-3,1.34-3,3v4.53c0,1.66,1.34,3,3,3H60 c1.66,0,3-1.34,3-3v-4.53C63,42.4,61.66,41.06,60,41.06L60,41.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.25,44.06v4.53h-5.95v-4.53H77.25 M77.25,41.06h-5.95c-1.66,0-3,1.34-3,3v4.53c0,1.66,1.34,3,3,3h5.95 c1.66,0,3-1.34,3-3v-4.53C80.25,42.4,78.91,41.06,77.25,41.06L77.25,41.06z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M85.69,67.24l0.12-5.74c3.55,3.17,5.78,7.78,5.78,12.92c0,9.57-7.76,17.33-17.32,17.33 s-17.32-7.76-17.32-17.33c0-9.57,7.76-17.32,17.32-17.32c2.22,0,4.34,0.42,6.28,1.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 91.59,
    y1: 61.5,
    x2: 85.81,
    y2: 61.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M77.03,74.42c0,1.52-1.23,2.75-2.75,2.75c-1.52,0-2.75-1.23-2.75-2.75c0-1.52,1.23-2.75,2.75-2.75 C75.8,71.67,77.03,72.9,77.03,74.42z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 74.18,
    y1: 62.86,
    x2: 74.18,
    y2: 71.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 65.65,
    y1: 74.42,
    x2: 71.53,
    y2: 74.42
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/Appointment.c87b67cfbd7f9d1314550490c2d19a78.svg";
export { ForwardRef as ReactComponent };